import journalPosts from './journal-posts.json';
import journalArchives from './journal-archives.json';

export const blogPosts = journalPosts;

// Keep published URLs available without featuring the previous editorial direction.
export const archivedPosts = journalArchives;
